import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { IRootState } from "../../../reducer/CombineReducer";
import { ExtractAddSlice } from "../ExtractAdd";
import { ExtractModes } from "../ExtractAdd/redux/Types";
import { ExtractListSlice } from "../ExtractList";
import { sortFunction } from "../ExtractList/Helper/helper";
import { extractSelectedType } from "../ExtractList/redux/Types";
import { FinancialYearView } from "./FinancialYear.view";
import { getYearRange } from "./Helper/Script";
import { IYearsList } from "./redux/Types";
import { FinancialSlice } from "./index";

/**
 * Responsible for implement financial year dropdown functional logic
 */
export const FinancialYear: React.FC = (): JSX.Element => {
  const dispatch = useDispatch();
  const [
    extractAdd,
    yearsState,
    extractState
  ] = useSelector((state: IRootState) => [
    state.extractAdd,
    state.yearsState,
    state.extractState
  ], shallowEqual);
  const [year, setYear] = useState(yearsState.selectedYear);
  const setSelectedYear = extractState?.selectedExtract?.financialYear;

  useEffect(() => {
    if (extractAdd.mode === ExtractModes.VIEW ||
      extractAdd.mode === ExtractModes.EDIT)
      setYear(yearsState.selectedYear);
  }, [extractAdd.mode, yearsState.selectedYear]);

  /**
   * Set financial year wrt the selected extract
   */
  useEffect(() => {
    if (setSelectedYear)
      setYear(setSelectedYear);
  }, [setSelectedYear]);

  /**
   * Updating finacial year redux state on component render
   * Set last 5 financial years
   * Default value is current year
   */
  useEffect(() => {
    const years = getYearRange();
    const date = new Date();
    if (yearsState.selectedYear === "") {
      const isFinancialYearChanged = (date.getMonth() + 1) <= 3;
      const currentFullYear = date.getFullYear();
      // To get the current year 
      const currentYear = years.filter((item: IYearsList): IYearsList | any => {
        const currentFinancialYear = isFinancialYearChanged ?
          currentFullYear.toString() : (currentFullYear + 1).toString();
        if (item.value.split("-")[1] === currentFinancialYear) {
          return item;
        }
      });
      dispatch(FinancialSlice.actions.setFinancialYear(years));
      dispatch(FinancialSlice.actions.selectedYear(currentYear?.[0].value));
      setYear(currentYear[0].value);
    }});

  const handleSelectItem = (year: string): void => {
    setYear(year);
    dispatch(FinancialSlice.actions.selectedYear(year));
    dispatch(ExtractAddSlice.actions.setExtractMode(ExtractModes.CREATE));
    const list = extractState && extractState.extractData &&
      extractState.extractData.data.attributes.extractList;
    if (list) {
      const sortedData = sortFunction(list);
      const firstExtract = sortedData[0];
      dispatch(ExtractListSlice.actions.selectedExtract(firstExtract));
    }
    dispatch(ExtractListSlice.actions.setClickedExtractIdDetails({} as extractSelectedType));
  };

  /**
   * Callback function for on change of financial year dropdown
   * Updating selected year in the redux state
   */
  const onYearChange = (selectedValue: string): void => {
    handleSelectItem(selectedValue);
  };

  return (
    <>
      <FinancialYearView
        selectedYear={year}
        yearsList={yearsState.yearsList}
        onYearChange={onYearChange}
      />
    </>
  );
};
